/* eslint-disable import/first */
import React from 'react';
import { Typography } from '@material-ui/core';
import ClassNames from 'classnames';
import { ImArrowRight2 } from '@react-icons/all-files/im/ImArrowRight2';
import exploreIcon from './images/explore.svg';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';

// TODO: Use Link component here to generate anchor tag
export default function ExploreMenu({ className, onClick }) {
  return (
    <div className={ClassNames(css.root, { [className]: className })} onClick={onClick}>
      <div className={css.actionBar}>
        <img src={exploreIcon} alt="" />
      </div>
      <div className={css.menuHeading}>
        <Typography variant="body1" component="h3">
          <FormattedMessage id="explore_menu" defaultMessage="Explore Menu" />
        </Typography>
        <Typography variant="body2" component="p">
          <FormattedMessage id="cart_addmoreitems" defaultMessage="Add more items in your cart" />
        </Typography>
      </div>
      <div className={css.actionBar}>
        <ImArrowRight2 />
      </div>
    </div>
  );
}
